<template>
  <van-form ref="form">
    <van-dialog
      v-model="visible"
      :title="title"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :before-close="beforeClose"
      @open="$emit('open')"
      @opened="$emit('opened')"
      @close="close"
      @closed="closed"
      style="border-radius:10px"
    >
      <van-field label="接收邮箱" clearable autofocus label-width="70" clear-trigger="always" v-model="email"
                 :rules="telRules"/>

      <van-checkbox v-model="defaultEmailChecked" style="margin: 12px;margin-left: 70px;">
        设定为默认接受邮箱
      </van-checkbox>
      <div>
        <div class="text-right" style="margin: 10px;">
          <van-button size="normal" @click="visible=!visible" style="height:36px" type="primary">
            {{ $t('B008', '取消') }}
          </van-button>
          &nbsp;
          <van-button style="height:36px" size="normal" type="info" @click="beforeClose('confirm')">
            {{ $t('B006', '确定') }}
          </van-button>
        </div>
      </div>
    </van-dialog>
  </van-form>
</template>

<script>
import { Dialog, Field, Checkbox,Form,Button } from 'vant'
import { localget, localset } from '@/business/utils/storage'

// 用于把指定地址的文件 发送到指定邮箱
export default {
  name: 'LdDownload',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Form.name]: Form,
    [Button.name]: Button ,
  },
  props: {
    url: [String],
    email: [String],
    sendScene: [String, Number],
    bdh: [String],
    orderNo: [String],
    orderType: [String],
    title: {
      type: String,
      default: '邮箱发送'
    },
  },
  data() {
    return {
      visible: false,
      defaultEmailChecked: false,
      userInfo: localget('userInfo')
    }
  },
  async created() {
    this.email = this.userInfo.empInfo.email
  },
  methods: {
    close() {
      this.visible = false
      this.$emit('close')
    },
    closed () {
      this.$nextTick(() => {
        this.$destroy(true)
        this.$el.parentNode.removeChild(this.$el) // 从DOM里将这个组件移除
        this.$emit('closed')
      })
    },
    async beforeClose(action, done) {
      if (action === 'confirm') {
        if (this.defaultEmailChecked) {
          await this.$api['common/commUpdateById']({
            id: this.userInfo.empInfo.empId,
            email: this.email
          })

          this.userInfo.empInfo.email = this.email
          localset('userInfo', this.userInfo || {})
        }
        this.$refs.form.validate().then(() => {
          this.$toast.success('发送成功')
          this.$api['common/smsEmail']({
            sendScene: this.sendScene,
            url: this.url,
            emailUrl: this.email,
            bdh: this.bdh,
            orderNo: this.orderNo,
            orderType: this.orderType
          })
          setTimeout(() => {
            setTimeout(this.visible = false, 1000)
          })
          return
        }).catch(() => {
          this.$toast.fail('发送失败')
          this.visible = false
          return
        })
        if (!this.mobile) return
        this.visible = false
      } else {
        this.visible = false
      }
    }
  }
}
</script>

<style lang="less">
</style>
